module.exports = __webpack_public_path__ + "img/salon26_logo_horizontal.d2370fb1.png";